namespace AgerLMS.LMS {
    export interface OrderItemForm {
        OrderId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        OrderItemEntityType: Serenity.EnumEditor;
        EntityId: Serenity.IntegerEditor;
        ItemName: Serenity.StringEditor;
        AmountPaid: Serenity.DecimalEditor;
        ItemPrice: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        Tax: Serenity.DecimalEditor;
        UsagePeriod: Serenity.IntegerEditor;
        Quantity: Serenity.IntegerEditor;
    }

    export class OrderItemForm extends Serenity.PrefixedContext {
        static formKey = 'LMS.OrderItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderItemForm.init)  {
                OrderItemForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.EnumEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(OrderItemForm, [
                    'OrderId', w0,
                    'UserId', w0,
                    'OrderItemEntityType', w1,
                    'EntityId', w0,
                    'ItemName', w2,
                    'AmountPaid', w3,
                    'ItemPrice', w3,
                    'Discount', w3,
                    'Tax', w3,
                    'UsagePeriod', w0,
                    'Quantity', w0
                ]);
            }
        }
    }
}
